import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";
import { use } from "react";

const PageAPI = createApi({
  reducerPath: "PageAPI",
  baseQuery: authBaseQuery,
  tagTypes: ['getPageMasterById'],
  endpoints: (builder) => ({
    enableDisabledPage: builder.mutation({
      query: ({ id, page_name }) => ({
        url: `v1/convert_disable_page_to_enable_in_page_master`,
        method: "PUT",
        body: { id, page_name },
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getAllPageLanguages: builder.query({
      query: () => {
        return "v1/get_all_page_languages";
      },
      transformResponse: (response) => ({
        data: response.data || [],
      }),
    }),

    updatePageMaster: builder.mutation({
      query: ({ pageMast_id, payload }) => ({
        url: `v1/pageMaster/${pageMast_id}`,
        method: "PUT",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ['getPageMasterById']
    }),
    createPageMaster: builder.mutation({
      query: (payload) => ({
        url: "v1/pageMaster",
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    checkPageExistence: builder.mutation({
      query: (payload) => ({
        url: "v1/check_page_exist_or_not",
        method: "POST",
        body: payload,
      }),
    }),
    getPriceTypesByPlatformId: builder.query({
      query: (platformId) => {
        return `v1/pagePriceTypesForPlatformId/${platformId}`;
      },
      transformResponse: (response) => response?.data || [],
    }),
    getPageMasterById: builder.query({
      query: (pageMasterId) => {
        return `v1/pageMaster/${pageMasterId}`;
      },
      transformResponse: (response) => response.data || {},
      providesTags: ['getPageMasterById']
    }),
    getDisabledPages: builder.query({
      query: () => {
        return `v1/get_disabled_pages`;
      },
    }),
    getVendorCounts: builder.query({
      query: () => {
        return "v1/get_vendor_counts";
      },
      transformResponse: (response) => response?.data || {},
    }),
    getVendorWisePages: builder.query({
      query: (vendorId) => `v1/vendor_wise_page_master_data/${vendorId}`,
      transformResponse: (response) => response?.data || [],
    }),

    getVendorDocumentCount: builder.query({
      query: (type = "") => {
        const queryParam = type ? `?type=${encodeURIComponent(type)}` : "";

        return `v1/get_vendor_document_count${queryParam}`;
      },
      transformResponse: (response) => ({
        documentCounts: Object.entries(
          response?.data?.documentCount?.[0] || {}
        ).map(([key, value]) => ({
          label: key,
          count: value,
        })),
        vendorData: response?.data?.vendorData || [],
      }),
    }),
    updatePageFollowersCount: builder.mutation({
      query: ({ _id, followers_count, vendor_id }) => ({
        url: `v1/pageMaster/${_id}`,
        method: "PUT",
        body: { followers_count, vendor_id },
      }),
    }),
    updateUnfetchedPages: builder.mutation({
      query: ({ page, new_value }) => ({
        url: `v1/update_unfetched_pages`,
        method: "PUT",
        body: { page, new_value },
      }),
    }),

    getAllTagCatData: builder.query({
      query: () => `v1/get_all_tag_cat`,
      transformResponse: (response) => response?.data || [],
    }),
    createTagCatName: builder.mutation({
      query: (payload) => ({
        url: "v1/add_tag_cat",
        method: "POST",
        body: payload,
      }),
    }),
    updateTagsCategory: builder.mutation({
      query: (payload) => ({
        url: "v1/edit_tag_cat",
        method: "PUT",
        body: payload,
      }),
    }),
    deleteTagCategory: builder.mutation({
      query: (id) => ({
        url: `v1//delete_tag_cat/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useEnableDisabledPageMutation,
  useGetAllPageLanguagesQuery,
  useUpdatePageMasterMutation,
  useCreatePageMasterMutation,
  useCheckPageExistenceMutation,
  useGetPriceTypesByPlatformIdQuery,
  useGetPageMasterByIdQuery,
  useLazyGetDisabledPagesQuery,
  useGetVendorCountsQuery,
  useGetVendorWisePagesQuery,
  useGetVendorDocumentCountQuery,
  useUpdatePageFollowersCountMutation,
  useUpdateUnfetchedPagesMutation,
  useGetAllTagCatDataQuery,
  useCreateTagCatNameMutation,
  useDeleteTagCategoryMutation,
  useUpdateTagsCategoryMutation,
} = PageAPI;

export default PageAPI;
